import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class MagicLink extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-magic-link-button', (event) => {
      return this.onSubmit(event);
    });
  }

  onSubmit(event) {

    let button = event.currentTarget,
        form = button.closest('form'),
        url  = button.data('action'),
        email = form.find('[type=email]').val();

    this.logger('Trying to send magic link');

    event.preventDefault();
    this.requestData(url, email, button);

  }

  requestData(url, email, button) {

    this.lockButton(button);

    this.App.Form.Submitter.resetErrors(form);

    return this.App.API.post(url, {email: value}).then((response) => {

      this.unlockButton(button);

      if (response.data) {
        return this.App.Form.Submitter.showCommonMessage(
          form,
          response.data.message,
          'success'
        );
      }

      return this.App.Form.Submitter.onFailedError(form);

    }).catch((error) => {

      this.unlockButton(button);

      this.logger('Form error:', error);

      if (error.response) {

        if (error.response.status === 422) {
          return this.App.Form.Submitter.onValidationError(
            form,
            error.response.data.message
          );
        }

        return this.App.Form.Submitter.onFailedError(form);

      } else if (error.request) {

        // Request failed (unknown reason)
        return this.App.Form.Submitter.onFailedError(form);

      }

      return this.App.Form.Submitter.onValidationError(
        form,
        error.message
      );

    });

  }

  lockButton(button) {
    button.prop('disabled', true).addClass('is-loading');
  }

  unlockButton(button) {
    button.prop('disabled', false).removeClass('is-loading');
  }

}